<template>
    <div class="overflow-x-hidden mt-12">
        <v-carousel
            :show-arrows="false"
            hide-delimiter-background
            color="info"
            height="430"
        >
            <v-carousel-item>
                <div class="border rounded-lg py-4 px-7">
                    <div class="google_review__comment">
                        {{ $t('referrers.carousel_item_1_review_comment') }}
                    </div>
                    <div class="pt-7">
                        <v-row align="center">
                            <v-col cols="12">
                                <div class="text-body-1 font-weight-bold">{{ $t('referrers.carousel_item_1_user_name') }}</div>
                                <v-rating color="warning" density="compact" model-value="5" readonly half-increments size="small"></v-rating>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-carousel-item>
            <v-carousel-item>
                <div class="border rounded-lg py-4 px-7">
                    <div class="google_review__comment">
                        {{ $t('referrers.carousel_item_2_review_comment') }}
                    </div>
                    <div class="pt-7">
                        <v-row align="center">
                            <v-col cols="12">
                                <div class="text-body-1 font-weight-bold">{{ $t('referrers.carousel_item_2_user_name') }}</div>
                                <v-rating color="warning" density="compact" model-value="5" readonly half-increments size="small"></v-rating>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-carousel-item>
            <v-carousel-item>
                <div class="border rounded-lg py-4 px-7">
                    <div class="google_review__comment">
                        {{ $t('referrers.carousel_item_3_review_comment') }}
                    </div>
                    <div class="pt-7">
                        <v-row align="center">
                            <v-col cols="12">
                                <div class="text-body-1 font-weight-bold">{{ $t('referrers.carousel_item_3_user_name') }}</div>
                                <v-rating color="warning" density="compact" model-value="5" readonly half-increments size="small"></v-rating>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-carousel-item>
        </v-carousel>
        <div class="text-body-2 d-flex justify-center align-center py-4">
            <div class="">{{ $t('referrers.rating_text') }}</div>
            <img alt="google" :width="18" :height="18" src="/images/campaigns/version-three/google.svg"  class="mx-2"/>
            <v-rating class="mb-1" color="warning" density="compact" model-value="5" readonly half-increments size="small"></v-rating>
        </div>
    </div>
</template>

<script>
export default {
  name: "GoogleReviews",
}
</script>

<style scoped>
.google_review__comment{
  height: 255px;
  overflow-y: auto;
}
.google_review__comment::-webkit-scrollbar {
  width: 5px;
}

.google_review__comment::-webkit-scrollbar-track {
  background-color: #F7F8FB;
}

.google_review__comment::-webkit-scrollbar-thumb {
  background-color: #108FE5;
  border-radius: 8px;
}
</style>
